import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import * as Tooltip from '@radix-ui/react-tooltip';

import { selectAuthUser } from '../../../../redux/auth/auth.selectors';
import { updateUser } from '../../../../redux/auth/auth.actions';
import {
    selectWorkspacePlan,
    selectCurrentWorkspace,
} from '../../../../redux/workspace/workspace.selectors';
import { toggleModalWorkspaceLeave } from '../../../../redux/main/main.actions';
import { getAvatarUrl } from '../../../../utils/get-avatar-url';
import { togglePricingPlanUpgrade } from '../../../../redux/main/main.actions';
import { getPaddle } from '../../../../billing/paddleClient';






// ─── Plan feature list ────────────────────────────────────────

const PLAN_FEATURES = {
    free: [
        'Up to 3 diagrams',
        'Up to 40 tables per diagram',
        'Up to 2 teams',
        'SQL / Image export',
        // 'Community support',
    ],
    basic: [
        'Up to 20 diagrams',
        'Team collaboration',
        'Share diagrams',
        'Priority support',
        // 'Up to 5 team seats',
    ],
    professional: [
        'Unlimited diagrams',
        // 'Unlimited team seats',
        'Unlimited teams',
        'Advanced collaboration',
        'Priority support',
        'Custom branding',
    ],
};

// ─── Icons ────────────────────────────────────────────────────
// ─── Icons ────────────────────────────────────────────────────

const LayoutIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
    </svg>
);

const TableIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="3" y1="15" x2="21" y2="15" /><line x1="12" y1="3" x2="12" y2="21" />
    </svg>
);

const BoxIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
    </svg>
);

const StickyIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15.5 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z" /><polyline points="14 3 14 8 21 8" />
    </svg>
);

const UsersIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);

const FolderIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
);

const TrendUpIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" />
    </svg>
);

// const CheckCircleIcon = () => (
//     <svg width="13" height="13" viewBox="0 0 20 20" fill="currentColor">
//         <path fillRule="evenodd" clipRule="evenodd"
//             d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" />
//     </svg>
// );

const ArrowRightIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
);

const ZapIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
);

const ShieldCheckIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><polyline points="9 12 11.5 14.5 16 9" />
    </svg>
);












const CreditCardIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
    </svg>
);

const FileTextIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
    </svg>
);

const DownloadIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
    </svg>
);

const MailIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
    </svg>
);

const RefreshIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
    </svg>
);

const CheckCircleIcon = () => (
    <svg width="13" height="13" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" />
    </svg>
);

const AlertIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
);

const BuildingIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="2" width="16" height="20" rx="2" ry="2" /><line x1="9" y1="6" x2="9" y2="6.01" /><line x1="15" y1="6" x2="15" y2="6.01" /><line x1="9" y1="10" x2="9" y2="10.01" /><line x1="15" y1="10" x2="15" y2="10.01" /><line x1="9" y1="14" x2="9" y2="14.01" /><line x1="15" y1="14" x2="15" y2="14.01" /><line x1="9" y1="18" x2="15" y2="18" />
    </svg>
);

const ArrowUpRightIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
    </svg>
);

// ─── Card brand icons ─────────────────────────────────────────

const VisaLogo = () => (
    <svg width="28" height="18" viewBox="0 0 780 500" fill="#1a1f71">
        <path d="M293.2 348.73l33.36-195.76h53.34l-33.38 195.76H293.2zm246.11-191.54c-10.57-3.97-27.16-8.22-47.88-8.22-52.73 0-89.87 26.58-90.14 64.65-.28 28.16 26.52 43.85 46.75 53.21 20.77 9.58 27.75 15.7 27.66 24.27-.14 13.11-16.59 19.1-31.93 19.1-21.37 0-32.71-2.97-50.22-10.26l-6.88-3.12-7.49 43.88c12.47 5.47 35.54 10.2 59.49 10.45 56.07 0 92.5-26.24 92.92-66.92.2-22.27-14.01-39.22-44.79-53.19-18.64-9.06-30.07-15.1-29.96-24.27 0-8.13 9.67-16.83 30.55-16.83 17.44-.28 30.09 3.53 39.93 7.5l4.78 2.25 7.24-42.5h-.03zm138.83-4.22h-41.23c-12.77 0-22.33 3.49-27.94 16.24l-79.28 179.52h56.06s9.16-24.13 11.23-29.43l68.33.08c1.6 7.06 6.5 29.35 6.5 29.35h49.53l-43.2-195.76zm-65.75 126.41c4.41-11.27 21.26-54.71 21.26-54.71-.32.52 4.38-11.33 7.07-18.68l3.6 16.87s10.22 46.73 12.36 56.52h-44.29zM238.23 152.97L186.12 289l-5.57-27c-9.67-31.12-39.83-64.86-73.55-81.75l47.82 168.37 56.45-.07 83.98-195.58h-56.02" />
    </svg>
);

const MastercardLogo = () => (
    <svg width="28" height="18" viewBox="0 0 40 26">
        <circle cx="14" cy="13" r="10" fill="#eb001b" /><circle cx="26" cy="13" r="10" fill="#f79e1b" />
        <path d="M20 5.3a10 10 0 0 0 0 15.4 10 10 0 0 0 0-15.4z" fill="#ff5f00" />
    </svg>
);

// ─── Section wrapper ──────────────────────────────────────────

const BillingSection = ({ icon, title, badge, action, children, className = '' }) => (
    <div className={`bil-section ${className}`}>
        <div className='bil-section-header'>
            <div className='bil-section-header-left'>
                {icon && <span className='bil-section-icon'>{icon}</span>}
                <span className='bil-section-title'>{title}</span>
                {badge && <span className='bil-section-badge'>{badge}</span>}
            </div>
            {action && <div className='bil-section-action'>{action}</div>}
        </div>
        <div className='bil-section-body'>
            {children}
        </div>
    </div>
);

// ─── Sample invoice data ──────────────────────────────────────

const SAMPLE_INVOICES = [
    { id: 'INV-2026-003', date: '2026-02-15', amount: '$10.00', status: 'paid', plan: 'Basic', period: 'Feb 2026' },
    { id: 'INV-2026-002', date: '2026-01-15', amount: '$10.00', status: 'paid', plan: 'Basic', period: 'Jan 2026' },
    { id: 'INV-2026-001', date: '2025-12-15', amount: '$10.00', status: 'paid', plan: 'Basic', period: 'Dec 2025' },
];

// ─── Main component ──────────────────────────────────────────

const SettingsBilling = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const currentUser = useSelector(selectAuthUser);
    const plan = useSelector(selectWorkspacePlan) || 'free';
    const workspace = useSelector(selectCurrentWorkspace);

    const [cancelStep, setCancelStep] = useState(0);

    const isFree = plan === 'free';
    const planLabel = plan.charAt(0).toUpperCase() + plan.slice(1);

    const isPaid = plan !== 'free';
    const features = PLAN_FEATURES[plan] || PLAN_FEATURES.free;

    // Renewal date from workspace
    const renewsAt = workspace?.renews_at || workspace?.renewsAt;
    const renewalText = isPaid && renewsAt
        ? `Renews ${new Date(renewsAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
        // : isPaid ? 'Active subscription' : 'No subscription needed';
        : isPaid ? 'Active subscription' : 'No renewal needed';



    // Billing data from workspace (when available)
    const billingEmail = workspace?.billing_email || currentUser?.email || '';
    const paymentMethod = workspace?.payment_method || null; // { brand: 'visa', last4: '4242', expiry: '12/28' }
    const nextPayment = workspace?.next_payment_date || workspace?.renews_at || workspace?.renewsAt || null;
    const billingCycle = workspace?.billing_cycle || 'monthly';
    const monthlyPrice = plan === 'basic' ? '$10' : plan === 'professional' ? '$16' : '$0';
    const invoices = workspace?.invoices || (isFree ? [] : SAMPLE_INVOICES);

    const formatDate = (iso) => {
        if (!iso) return '—';
        return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    };

    const handleUpdatePayment = useCallback(async () => {
        try {
            const paddle = await getPaddle();
            // Paddle's update payment method flow
            if (paddle.Checkout?.open) {
                paddle.Checkout.open({
                    settings: { displayMode: 'overlay', theme: 'light' },
                    customer: { email: currentUser?.email || '' },
                });
            }
        } catch (e) { /* silent */ }
    }, [currentUser?.email]);

    const statusIcon = (status) => {
        if (status === 'paid') return <span className='bil-status-icon paid'><CheckCircleIcon /></span>;
        if (status === 'pending') return <span className='bil-status-icon pending'><RefreshIcon /></span>;
        return <span className='bil-status-icon failed'><AlertIcon /></span>;
    };

    const statusLabel = (status) => {
        if (status === 'paid') return 'Paid';
        if (status === 'pending') return 'Pending';
        return 'Failed';
    };

    return (
        <div className='settings-wrap'>
            <div className='settings-header'>{t('settings_page.billing.header')}</div>


            {/* <div className='usg-plan-hero'>
                <div className='usg-plan-hero-bg' />
                <div className='usg-plan-hero-content'>
                    <div className='usg-plan-hero-left'>



                        <span className='usg-plan-hero-label'>Subscription</span>
                        <div className='usg-plan-hero-name-row'>
                            <span className='usg-plan-hero-name'>{planLabel}</span>
                            <span className="usg-plan-hero-active-badge">Active</span>
                            {isPaid && <span className='usg-plan-hero-active-badge'>Active</span>}
                        </div>
                        <span className='usg-plan-hero-renews'>{renewalText}</span>
                    </div>
                    <div className='usg-plan-hero-right'>
                        {plan !== 'professional' && (
                            <button
                                className='usg-upgrade-btn'
                                onClick={() => dispatch(togglePricingPlanUpgrade('settings'))}
                            >
                                Upgrade
                            </button>
                        )}
                    </div>
                </div>
            </div> */}

            {/* ── Hero card ─────────────────────────────────────── */}
            <div className='settings-hero hero-billing'>
                <div className='settings-hero-info'>
                    <div className='settings-hero-title'>
                        <div className='settings-hero-title-plan'>{t('settings_page.billing.plan_free') || '—'}</div>
                        <div className='settings-hero-title-status'>{t('settings_page.billing.status_current') || '—'}</div>
                    </div>
                    <div className='settings-hero-subtitle'>{t('settings_page.billing.no_renewal_needed') || ''}</div>
                </div>
                <button
                    className='settings-hero-btn'
                    onClick={() => dispatch(togglePricingPlanUpgrade('main'))}
                >
                    {t('dropdown_ctrl_settings.upgrade_plan')}
                </button>
            </div>

            {/* ── Payment ─────────────────────────────────────── */}
            <div className='settings-subheader'>{t('settings_page.billing.payment_header')}</div>
            <div className='settings-section'>
                <div className='settings-row'>
                    <div className='settings-row-left'>
                        <span className='settings-row-label'>{t('settings_page.billing.no_payments')}</span>
                        {/* <span className='settings-row-sub'>Payments will appear here after your payments</span> */}
                    </div>
                </div>
            </div>

            {/* ── Invoices ─────────────────────────────── */}
            <div className='settings-subheader'>{t('settings_page.billing.invoices_header')}</div>
            <div className='settings-section'>
                <div className='settings-row'>
                    <div className='settings-row-left'>
                        <span className='settings-row-label'>{t('settings_page.billing.no_invoices')}</span>
                        {/* <span className='settings-row-sub'>Invoices will appear here after your payments</span> */}
                    </div>

                </div>
            </div>

            {/* <div className='settings-section'>
                <div className='settings-row'>
                    <div className='settings-row-left'>
                        <span className='settings-row-label'>Cancellation</span>
                    </div>
                    <button
                        className='settings-row-btn btn-delete'
                        // onClick={() => dispatch(toggleModalWorkspaceLeave(workspace))}
                        // disabled={!workspace?.id}
                    >
                        Cancel plan
                    </button>
                </div>
            </div> */}

        </div>
        // <div className='bil-wrap'>

        //     {/* ── Plan Hero ────────────────────────────────────────── */}
        //     <div className='usg-plan-hero'>
        //         <div className='usg-plan-hero-bg' />
        //         <div className='usg-plan-hero-content'>
        //             <div className='usg-plan-hero-left'>



        //                 <span className='usg-plan-hero-label'>Subscription</span>
        //                 <div className='usg-plan-hero-name-row'>
        //                     <span className='usg-plan-hero-name'>{planLabel}</span>
        //                     <span className="usg-plan-hero-active-badge">Active</span>
        //                     {isPaid && <span className='usg-plan-hero-active-badge'>Active</span>}
        //                 </div>
        //                 <span className='usg-plan-hero-renews'>{renewalText}</span>
        //             </div>
        //             <div className='usg-plan-hero-right'>
        //                 {plan !== 'professional' && (
        //                     <button
        //                         className='usg-upgrade-btn'
        //                         onClick={() => dispatch(togglePricingPlanUpgrade('settings'))}
        //                     >
        //                         Upgrade
        //                     </button>
        //                 )}
        //             </div>
        //         </div>
        //         {/* Plan features */}
        //         <div className='usg-plan-features'>
        //             {features.map((f, i) => (
        //                 <div key={i} className='usg-plan-feature'>
        //                     <span className='usg-plan-feature-check'><CheckCircleIcon /></span>
        //                     <span className='usg-plan-feature-text'>{f}</span>
        //                 </div>
        //             ))}
        //         </div>
        //     </div>

        //     {/* ── Subscription Overview ────────────────────────── */}
        //     {/* <div className='bil-sub-hero'>
        //         <div className='bil-sub-hero-bg' />
        //         <div className='bil-sub-hero-content'>
        //             <div className='bil-sub-hero-left'>
        //                 <span className='bil-sub-hero-label'>Subscription</span>
        //                 <div className='bil-sub-hero-plan-row'>
        //                     <span className='bil-sub-hero-plan'>{planLabel}</span>
        //                     {!isFree && (
        //                         <span className='bil-sub-hero-cycle-badge'>
        //                             {billingCycle === 'annual' ? 'Annual' : 'Monthly'}
        //                         </span>
        //                     )}
        //                 </div>
        //                 <div className='bil-sub-hero-price-row'>
        //                     {isFree ? (
        //                         <span className='bil-sub-hero-price-text'>Free forever</span>
        //                     ) : (
        //                         <>
        //                             <span className='bil-sub-hero-price'>{monthlyPrice}</span>
        //                             <span className='bil-sub-hero-price-period'>/user/month</span>
        //                         </>
        //                     )}
        //                 </div>
        //                 {!isFree && nextPayment && (
        //                     <span className='bil-sub-hero-next'>
        //                         Next payment on {formatDate(nextPayment)}
        //                     </span>
        //                 )}
        //             </div>
        //             <div className='bil-sub-hero-right'>
        //                 <button
        //                     className='bil-sub-hero-btn'
        //                     onClick={() => dispatch(togglePricingPlanUpgrade('billing'))}
        //                 >
        //                     {isFree ? 'Upgrade plan' : 'Current plan'}
        //                 </button>
        //             </div>
        //         </div>
        //     </div> */}

        //     {/* ── Payment Method ───────────────────────────────── */}
        //     <BillingSection
        //         // icon={<CreditCardIcon />}
        //         title='Payment Method'
        //         action={
        //             !isFree && (
        //                 <button className='bil-action-btn' onClick={handleUpdatePayment}>
        //                     Update
        //                 </button>
        //             )
        //         }
        //     >
        //         {isFree ? (
        //             <div className='bil-empty-state'>
        //                 <span className='bil-empty-icon'><CreditCardIcon /></span>
        //                 <div className='bil-empty-text'>
        //                     <span className='bil-empty-title'>No payment method</span>
        //                     <span className='bil-empty-desc'>Add a payment method when you upgrade to a paid plan.</span>
        //                 </div>
        //             </div>
        //         ) : paymentMethod ? (
        //             <div className='bil-card-display'>
        //                 <div className='bil-card-left'>
        //                     <span className='bil-card-brand'>
        //                         {paymentMethod.brand === 'mastercard' ? <MastercardLogo /> : <VisaLogo />}
        //                     </span>
        //                     <div className='bil-card-info'>
        //                         <span className='bil-card-number'>
        //                             •••• •••• •••• {paymentMethod.last4}
        //                         </span>
        //                         <span className='bil-card-expiry'>Expires {paymentMethod.expiry}</span>
        //                     </div>
        //                 </div>
        //                 <span className='bil-card-default-badge'>Default</span>
        //             </div>
        //         ) : (
        //             <div className='bil-card-display'>
        //                 <div className='bil-card-left'>
        //                     <span className='bil-card-brand'><VisaLogo /></span>
        //                     <div className='bil-card-info'>
        //                         <span className='bil-card-number'>•••• •••• •••• 4242</span>
        //                         <span className='bil-card-expiry'>Expires 12/28</span>
        //                     </div>
        //                 </div>
        //                 <span className='bil-card-default-badge'>Default</span>
        //             </div>
        //         )}
        //     </BillingSection>

        //     {/* ── Billing Contact ──────────────────────────────── */}
        //     {/* <BillingSection icon={<MailIcon />} title='Billing Information'>
        //         <div className='bil-details-grid'>
        //             <div className='bil-detail-item'>
        //                 <div className='bil-detail-icon'><MailIcon /></div>
        //                 <div className='bil-detail-info'>
        //                     <span className='bil-detail-label'>Billing email</span>
        //                     <span className='bil-detail-value'>{'—'}</span>
        //                 </div>
        //             </div>
        //             <div className='bil-detail-item'>
        //                 <div className='bil-detail-icon'><BuildingIcon /></div>
        //                 <div className='bil-detail-info'>
        //                     <span className='bil-detail-label'>Company</span>
        //                     <span className='bil-detail-value'>{workspace?.company_name || '—'}</span>
        //                 </div>
        //             </div>
        //             <div className='bil-detail-item'>
        //                 <div className='bil-detail-icon'><FileTextIcon /></div>
        //                 <div className='bil-detail-info'>
        //                     <span className='bil-detail-label'>Tax ID</span>
        //                     <span className='bil-detail-value'>{workspace?.tax_id || '—'}</span>
        //                 </div>
        //             </div>
        //             <div className='bil-detail-item'>
        //                 <div className='bil-detail-icon'><RefreshIcon /></div>
        //                 <div className='bil-detail-info'>
        //                     <span className='bil-detail-label'>Billing cycle</span>
        //                     <span className='bil-detail-value'>
        //                         {isFree ? '—' : billingCycle === 'annual' ? 'Annual' : 'Monthly'}
        //                     </span>
        //                 </div>
        //             </div>
        //         </div>
        //     </BillingSection> */}

        //     {/* ── Invoices ─────────────────────────────────────── */}
        //     <BillingSection
        //         // icon={<FileTextIcon />}
        //         title='Invoices'
        //         badge={invoices.length > 0 ? `${invoices.length} total` : null}
        //     >
        //         {invoices.length === 0 ? (
        //             <div className='bil-empty-state'>
        //                 <span className='bil-empty-icon'><FileTextIcon /></span>
        //                 <div className='bil-empty-text'>
        //                     <span className='bil-empty-title'>No invoices yet</span>
        //                     <span className='bil-empty-desc'>Invoices will appear here after your first payment.</span>
        //                 </div>
        //             </div>
        //         ) : (
        //             <div className='bil-invoices-table'>
        //                 <div className='bil-invoices-header'>
        //                     <span className='bil-inv-col id'>Invoice</span>
        //                     <span className='bil-inv-col period'>Period</span>
        //                     <span className='bil-inv-col date'>Date</span>
        //                     <span className='bil-inv-col amount'>Amount</span>
        //                     <span className='bil-inv-col status'>Status</span>
        //                     <span className='bil-inv-col actions'></span>
        //                 </div>
        //                 {invoices.map((inv) => (
        //                     <div key={inv.id} className='bil-invoice-row'>
        //                         <span className='bil-inv-col id'>
        //                             <span className='bil-inv-id'>{inv.id}</span>
        //                         </span>
        //                         <span className='bil-inv-col period'>{inv.period}</span>
        //                         <span className='bil-inv-col date'>{formatDate(inv.date)}</span>
        //                         <span className='bil-inv-col amount'>{inv.amount}</span>
        //                         <span className='bil-inv-col status'>
        //                             <span className={`bil-inv-status ${inv.status}`}>
        //                                 {statusIcon(inv.status)}
        //                                 {statusLabel(inv.status)}
        //                             </span>
        //                         </span>
        //                         <span className='bil-inv-col actions'>
        //                             <button className='bil-inv-download' title='Download invoice'>
        //                                 <DownloadIcon />
        //                             </button>
        //                             <button className='bil-inv-open' title='Open'>
        //                                 <ArrowUpRightIcon />
        //                             </button>
        //                         </span>
        //                     </div>
        //                 ))}
        //             </div>
        //         )}
        //     </BillingSection>

        //     {/* ── Cancel Subscription ──────────────────────────── */}
        //     {!isFree && (
        //         <BillingSection title='Cancel Subscription' className='bil-danger'>
        //             <div className='bil-cancel-content'>
        //                 <div className='bil-cancel-info'>
        //                     <div className='bil-cancel-title'>Cancel your subscription</div>
        //                     <div className='bil-cancel-desc'>
        //                         Your plan will remain active until the end of the current billing period.
        //                         After cancellation, your account will revert to the Free plan.
        //                     </div>
        //                 </div>

        //                 {cancelStep === 0 && (
        //                     <button className='pref-btn-danger' onClick={() => setCancelStep(1)}>
        //                         Cancel subscription
        //                     </button>
        //                 )}

        //                 {cancelStep === 1 && (
        //                     <div className='bil-cancel-confirm'>
        //                         <span className='bil-cancel-confirm-text'>
        //                             Are you sure you want to cancel? You'll lose access to paid features
        //                             at the end of your billing cycle.
        //                         </span>
        //                         <div className='bil-cancel-confirm-row'>
        //                             <button className='pref-btn-danger' onClick={() => {
        //                                 // TODO: dispatch cancel subscription action
        //                                 setCancelStep(0);
        //                             }}>
        //                                 Yes, cancel
        //                             </button>
        //                             <button className='prof-btn-ghost' onClick={() => setCancelStep(0)}>
        //                                 Keep subscription
        //                             </button>
        //                         </div>
        //                     </div>
        //                 )}
        //             </div>
        //         </BillingSection>
        //     )}
        // </div>
    );
};

export default SettingsBilling;
